import { useContext } from "react";
import ItemContext from "./ItemContext";

export default function useItemStore() {
  return useContext(ItemContext);
}
